import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { intlMessageShape } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import { CSSTransition } from 'react-transition-group';
import When from 'components/When';
import Isvg from 'react-inlinesvg';
import { ICONS } from 'constants/icons';
import Message from 'components/Message';
import './Snackbar.scss';

const ANIMATION_SPEED = 200;
const { block, element } = bem('snackbar');

const Snackbar = ({
  id,
  className,
  isLowStyle,
  messageProps,
  type,
  icon,
  skipIntl,
  registerSnackbar,
  deregisterSnackbar,
  hideSnackbar,
  description,
}) => {
  const [message, setMessage] = useState(messageProps || '');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (messageProps) {
      setMessage(messageProps);
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [messageProps]);

  useEffect(() => {
    registerSnackbar({ id });
    return () => {
      deregisterSnackbar({ id });
    };
  }, [id]);

  let selectedIcon = null;
  if (type === 'success') {
    selectedIcon = ICONS.success;
  } else if (type === 'error') {
    selectedIcon = ICONS.error;
  }

  return (
    <CSSTransition
      className={block(className, { low: isLowStyle })}
      classNames={block()}
      in={visible}
      onExited={hideSnackbar}
      timeout={ANIMATION_SPEED}
      mountOnEnter
      unmountOnExit>
      <div>
        <div
          className={element('wrapper', {
            success: type === 'success',
            error: type === 'error',
          })}>
          <Isvg className={element('icon')} src={icon || selectedIcon} />
          <When predicate={skipIntl}>
            <div className={element('message')}>{message}</div>
          </When>
          <When predicate={!skipIntl}>
            <Message as="div" className={element('message')} message={message} />
          </When>
          <When predicate={!!description}>
            <Message as="div" className={element('description')} message={description} />
          </When>
          <button className={element('close-button')} type="button" onClick={() => setVisible(false)}>
            <Isvg src={ICONS.cardsClose} />
          </button>
        </div>
      </div>
    </CSSTransition>
  );
};

Snackbar.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  isLowStyle: PropTypes.bool,
  messageProps: PropTypes.oneOfType([
    PropTypes.shape({
      ...intlMessageShape,
      values: PropTypes.shape({}), // could be almost any shape
    }),
    PropTypes.string,
  ]),
  type: PropTypes.oneOf(['success', 'error']),
  icon: PropTypes.string,
  skipIntl: PropTypes.bool,
  registerSnackbar: PropTypes.func,
  deregisterSnackbar: PropTypes.func,
  hideSnackbar: PropTypes.func,
  description: PropTypes.shape({
    ...intlMessageShape,
    values: PropTypes.shape({}), // could be almost any shape
  }),
};

export default Snackbar;
